import { NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { TABLE_ICON_MAP, TableIconStatus } from './table-icon.const';

@Component({
  selector: 'ui-table-icon',
  standalone: true,
  imports: [NgClass],
  templateUrl: './table-icon.component.html',
  styleUrl: './table-icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableIconComponent {
  public readonly status = input<TableIconStatus>('default');

  protected readonly config = computed(() => TABLE_ICON_MAP[this.status()]);
  protected readonly bgCssClass = computed(() => this.config().backgroundColor);
  protected readonly iconCssClass = computed(() => this.config().iconColor);
  protected readonly iconName = computed(() => this.config().iconName);
}
